module.exports = __webpack_public_path__ + "display-icon.png?2afe8baf6a647f4ecf187866d65dbc26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/display-icon.png
// module id = 25
// module chunks = 0